// Catalogage en démonstration : lectures locales, aucun appel fournisseur ou réseau.
import { ApiError } from './errors.js';

export function reponseDemoCatalogage(chemin: string, methode: string): unknown {
  if (chemin === '/catalogage' && methode === 'GET')
    return { propositions: [], cartels: [], serie: null };
  // Les démonstrations ne disposent d’aucun droit publié sur cet add-on.
  throw new ApiError(403, 'module.indisponible', 'Cette fonction est indisponible.');
}
